import { Directive } from '@angular/core';

/**
 * Button Sidebar Directive
 *
 * Adds sidebar button styling to PrimeNG buttons.
 * Use with p-button for navigation menu items in sidebars.
 *
 * @example
 * <p-button pButtonSidebar icon="pi pi-home" label="Home" />
 * <p-button pButtonSidebar icon="pi pi-users" label="Users" [selected]="true" />
 *
 * @usageNotes
 * The directive uses attribute selector styling - no class manipulation needed.
 * Styles are applied via [pButtonSidebar] CSS selector in the preset.
 * Add the 'selected' class to the p-button component wrapper for active state.
 */
@Directive({
  selector: 'p-button[pButtonSidebar], button[pButton][pButtonSidebar], a[pButton][pButtonSidebar]',
  standalone: true,
})
export class ButtonSidebarDirective {}
